<!-- Main container for sidebar + content -->
@if(!isLoading){
<div class="main-container">
  <!-- Sidebar Navigation (desktop only) -->
  <mat-nav-list class="sidebar desktop-only">
    <mat-list-item *ngFor="let tab of getVisibleTabs()" [class.active]="activeTab === tab.id" (click)="openTab(tab.id)">
      <mat-icon>{{ tab.icon }}</mat-icon>
      <span>{{ tab.name }}</span>
    </mat-list-item>
  </mat-nav-list>

  <!-- Content -->
  <div class="content">
    <!-- Active Tab Header -->
     @if (
     activeTab!='sentiment-tracking' &&
     activeTab!='ai-citations' &&
     activeTab!='category-analysis') {
    <div class="active-tab-header">
      <div class="active-tab-info">
        <mat-icon>{{ getActiveTabIcon() }}</mat-icon>
        <span class="active-tab-name">{{ getTabTitle(activeTab || 'overview') }}</span>
      </div>
      <div class="header-actions">
        <button mat-icon-button color="primary" (click)="reloadCurrentTab()" [disabled]="isTabLoading || isLoading"
          class="reload-button" title="Reload {{ getTabTitle(activeTab || 'overview') }}">
          <mat-icon>refresh</mat-icon>
        </button>
        <button class="mobile-tab-menu mobile-only" mat-icon-button [matMenuTriggerFor]="tabMenu"
          aria-label="Open tab menu">
          <mat-icon>menu</mat-icon>
        </button>
      </div>
    </div>
    }

    <!-- Global Tab Selection Menu (for mobile) -->
    <mat-menu #tabMenu="matMenu">
      <button mat-menu-item *ngFor="let tab of getVisibleTabs()" (click)="openTab(tab.id)">
        <mat-icon>{{ tab.icon }}</mat-icon>
        <span>{{ tab.name }}</span>
      </button>
    </mat-menu>


    <div class="tab-content">
      <!-- Overview Tab -->
      @if(activeTab==='overview'){
      <div class="overview-tab">
        <app-education-overview [selectedEntities]="selectedEntities"></app-education-overview>
      </div>
      }

      <!-- AI Visibility Index Tab -->
      @if(activeTab==='ai-visibility-index'){
      <div class="tab-container">
        @if(!isTabLoading){
        @if(tabData?.ai_visibility_data || tabData){
        <app-ai-visibility [aiVisibilityResponse]="tabData.ai_visibility_data || tabData">
        </app-ai-visibility>
        } @else {
        <div class="no-data-message">
          <mat-icon>visibility_off</mat-icon>
          <h3>No AI Visibility Data Available</h3>
          <p>Please select universities and try again.</p>
        </div>
        }
        }
      </div>
      }

      <!-- AI Citations Tab -->
      @if(activeTab==='ai-citations'){
      <div class="tab-container">
        <app-ai-citations
          [title]="getTabTitle(activeTab)">
        </app-ai-citations>
      </div>
      }

      <!-- Sentiment Tracking Tab -->
      @if(activeTab==='sentiment-tracking'){
      <div class="tab-container">
        @if(!isTabLoading){
        <app-sentiment-analysis-tab [analysisSentiment]="transformSentimentAnalysis(tabData)" [data]="tabData"
          [brands]="getEntityNames()" [title]="getTabTitle(activeTab)">
        </app-sentiment-analysis-tab>
        }
      </div>
      }

      <!-- Category Analysis Tab -->
      @if(activeTab==='category-analysis'){
      <div class="tab-container">
        @if(!isTabLoading){
        <app-category-analysis-tab [analysisConsumerPreference]="transformConsumerPreference(tabData)" [data]="tabData"
          [brands]="getEntityNames()" [title]="getTabTitle(activeTab)">
        </app-category-analysis-tab>
        }
      </div>
      }

      <!-- New Category Tab -->
      @if(activeTab==='category'){
      <div class="tab-container">
        @if(!isTabLoading){
        <app-category-analysis-tab [data]="tabData" [title]="getTabTitle(activeTab)">
        </app-category-analysis-tab>
        }
      </div>
      }

      <!-- AI Content Index Tab -->
      @if(activeTab==='ai-content-index'){
      <div class="tab-container">
        @if(!isTabLoading){
        <app-ai-content-index [tabData]="tabData" [config]="config" [evidenceSources]="evidenceSources"
          [recommendations]="recommendations">
        </app-ai-content-index>
        }
      </div>
      }

      <!-- Content Creation Tab -->
      @if(activeTab==='content-creation'){
      <div class="tab-container">
        @if(!isTabLoading){
        <app-content-creation [tabData]="tabData" [config]="config" [evidenceSources]="evidenceSources"
          [recommendations]="recommendations">
        </app-content-creation>
        }
      </div>
      }

      <!-- Area Comparison Tab -->
      @if(activeTab==='area-comparison'){
      <div class="tab-container">
        @if(!isTabLoading){
        <app-common-roi-comparision [tabData]="tabData" [config]="config" [evidenceSources]="evidenceSources"
          [recommendations]="recommendations">
        </app-common-roi-comparision>
        }
      </div>
      }


      <!-- NEW: Our Methodology Tab -->
      @if(activeTab==='methodology'){
      <div class="tab-container">
        @if(!isTabLoading){
        @if(tabData?.methodology_data || tabData){
        <app-common-methodology [data]="tabData" [universities]="getEntityNames()" [title]="getTabTitle(activeTab)" [evidenceSources]="evidenceSources" [recommendations]="recommendations">
        </app-common-methodology>
        } @else {
        <div class="no-data-message">
          <mat-icon>science</mat-icon>
          <h3>No Methodology Data Available</h3>
          <p>Please select universities and try again.</p>
        </div>
        }

        }
      </div>
      }

      <!-- NEW: Performance Tracking Tab -->
      @if(activeTab==='performance-tracking'){
      <div class="tab-container">
        @if(!isTabLoading){
        <!-- Enhanced Performance Tracking Component -->
        @if(tabData?.performance_tracking_data || tabData){
        <app-common-performance-tracking [data]="tabData" [universities]="getEntityNames()"
          [title]="getTabTitle(activeTab)">
        </app-common-performance-tracking>
        }
        @else{
        <div class="no-data-message">
          <mat-icon>trending_up</mat-icon>
          <h3>No Performance Tracking Data Available</h3>
          <p>Please select universities and try again.</p>
        </div>
        }

        <!-- Enhanced Analysis Evidence and Recommendations -->
        <app-evidence-and-recommendations
          [evidenceSources]="evidenceSources"
          [recommendations]="recommendations"
          [evidenceTitle]="'Performance Data Sources'"
          [recommendationsTitle]="'Performance Improvement Recommendations'">
        </app-evidence-and-recommendations>
        }
      </div>
      }


      <!-- NEW: Consumer Insights Tab -->
      @if(activeTab==='consumer-insights'){
      <div class="tab-container">
        @if(!isTabLoading){
        <!-- Enhanced Consumer Insights Component -->
        @if(tabData?.consumer_insights_data || tabData){
        <app-common-consumer-insights [data]="tabData" [universities]="getEntityNames()"
          [title]="getTabTitle(activeTab)">
        </app-common-consumer-insights>
        }
        @else{
        <div class="no-data-message">
          <mat-icon>psychology</mat-icon>
          <h3>No Consumer Insights Data Available</h3>
          <p>Please select universities and try again.</p>
        </div>
        }
        }
      </div>
      }

      <!-- Loading State for Tabs -->
      @if(activeTab && activeTab !== 'overview' && isTabLoading){
      <div class="tab-loading-state">
        <mat-card>
          <mat-card-content>
            <div class="tab-loading-content">
              <mat-spinner diameter="40"></mat-spinner>
              <h3>Loading {{ getTabTitle(activeTab) }}</h3>
              <p>Analyzing {{ getEntityText() }}...</p>
              <p class="loading-subtitle">Please wait while we process your request</p>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
      }

      <!-- Error State for Tabs -->
      @if(activeTab && activeTab !== 'overview' && error){
      <div class="error-state">
        <mat-card>
          <mat-card-content>
            <div class="error-content">
              <mat-icon>error</mat-icon>
              <h3>Error Loading Data</h3>
              <p>{{ error }}</p>
              <button mat-raised-button color="primary" (click)="openTab(activeTab)">
                <mat-icon>refresh</mat-icon>
                Try Again
              </button>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
      }

      <!-- Empty State for Tabs -->
      @if(activeTab && activeTab !== 'overview' && !tabData && !isTabLoading && !error){
      <div class="empty-state">
        <mat-card>
          <mat-card-content>
            <div class="empty-content">
              <mat-icon>analytics</mat-icon>
              <h3>No Data Available</h3>
              <p>No analysis data found for {{ getTabTitle(activeTab) }}</p>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
      }
    </div>
  </div>
</div>
}

<!-- Loading State -->
@if(isLoading){
<div class="loading-state">
  <div class="loading-content">
    <mat-spinner diameter="40"></mat-spinner>
    <p>Loading {{ config.entityPlural }}...</p>
  </div>
</div>
}

<!-- Error Display -->
@if(error){
<div class="error">{{ error }}</div>
}
